// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__i_xjg","title":"styles_title__248lO"};